import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { 
		clsx
	} from 'clsx'

	import {
		computed,
		getCurrentInstance,
		provide,
		readonly
	} from 'vue'


	
export default /*#__PURE__*/_defineComponent({
  __name: 'VCheckboxField',
  props: {
		disabled: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const fieldDisabled = computed(() => {
		return props.disabled
	})
	provide('fieldDisabled', readonly(fieldDisabled))

	const controlId = 'control-' + getCurrentInstance()?.uid
	provide('controlId', controlId)

	const labelId = 'label-' + getCurrentInstance()?.uid
	provide('labelId', labelId)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-slot": "field",
    class: _normalizeClass(_unref(clsx)(
			// Base layout
			'grid grid-cols-[1.125rem_1fr] items-center gap-x-4 gap-y-1 sm:grid-cols-[1rem_1fr]',
			// Control layout
			'*:data-[slot=control]:col-start-1 *:data-[slot=control]:row-start-1 *:data-[slot=control]:justify-self-center',
			// Label layout
			'*:data-[slot=label]:col-start-2 *:data-[slot=label]:row-start-1 *:data-[slot=label]:justify-self-start',
			// Description layout
			'*:data-[slot=description]:col-start-2 *:data-[slot=description]:row-start-2',
			// With description
			'has-data-[slot=description]:**:data-[slot=label]:font-medium'
		))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})